// API Configuration - VITE_API_URL is set in .env (see .env.example)
function getApiBaseUrl(): string {
  const raw =
    typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : undefined;
  const url = typeof raw === 'string' ? raw.trim() : '';
  return url !== '' ? url.replace(/\/$/, '') : 'http://localhost:3001';
}
export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  AUTH: {
    REQUEST_CODE: '/auth/request-code',
    VERIFY_CODE: '/auth/verify-code',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
    CONFIG: '/auth/config',
    GOOGLE: `${API_BASE_URL}/auth/google`,
  },
  WORKSPACES: {
    BASE: '/workspaces',
    BY_ID: (id: string) => `/workspaces/${id}`,
    MEMBERS: (id: string) => `/workspaces/${id}/members`,
    MEMBER_BY_ID: (id: string, memberId: string) => `/workspaces/${id}/members/${memberId}`,
    INVITATIONS: (id: string) => `/workspaces/${id}/invitations`,
    INVITATION_BY_ID: (id: string, invitationId: string) => `/workspaces/${id}/invitations/${invitationId}`,
  },
  PROJECTS: {
    IN_WORKSPACE: (workspaceId: string) => `/workspaces/${workspaceId}/projects`,
    BY_ID: (projectId: string) => `/projects/${projectId}`,
  },
  CHATS: {
    BASE: '/chats',
    BY_ID: (id: string) => `/chats/${id}`,
    MESSAGES: (chatId: string) => `/chats/${chatId}/messages`,
    INPUT_SUMMARY: '/chats/context/input-summary',
  },
  PAYMENTS: {
    CREATE_INTENT: '/payments/create-intent',
    HISTORY: '/payments/history',
    INVOICES: '/payments/invoices',
    SUBSCRIPTION: '/payments/subscription',
    CANCEL: '/payments/cancel',
    UPGRADE: '/payments/upgrade',
    DOWNGRADE: '/payments/downgrade',
    REACTIVATE: '/payments/reactivate',
  },
  USERS: {
    ME: '/users/me',
    CREDITS: '/users/me/credits',
    CREDITS_USAGE: '/users/me/credits/usage',
    CONSUME_CREDITS: '/users/me/credits/consume',
    SET_WORKSPACE: '/users/me/workspace',
  },
  SESSIONS: {
    BASE: '/sessions',
    BY_ID: (id: string) => `/sessions/${id}`,
  },
  PLANS: {
    BASE: '/plans',
    ME: '/plans/me',
    ASSIGN: '/plans/assign',
    BY_ID: (id: string) => `/plans/${id}`,
  },
  DOCS: {
    BASE: '/docs',
    BY_ID: (id: string) => `/docs/${id}`,
    BY_CHAT: (chatId: string) => `/docs?chatId=${chatId}`,
  },
  WAITLIST: '/waitlist',
} as const;
